import {
    ADD_TESTIMONIAL,
    DELETE_TESTIMONIALS,
    GET_TESTIMONIALS,
    TOGGLE_TESTIMONIALS,
    UPDATE_TESTIMONIALS
} from "../actions/types";

const initialState = {};

export default function (state = initialState, action) {
    switch (action.type) {
        case GET_TESTIMONIALS:
            return {
                ...state,
                testimonials: action.payload,
            };
        case ADD_TESTIMONIAL:
            return {
                ...state,
                message : action.message,
                newTestimonial: action.payload
            };
        case TOGGLE_TESTIMONIALS:
            return {
                ...state,
                message : action.message,
                updatedTestimonial: action.payload
            };
        case UPDATE_TESTIMONIALS:
            return {
                ...state,
                message : action.message,
                updatedTestimonial: action.payload
            };
        case DELETE_TESTIMONIALS:
            return {
                ...state,
                message : action.message,
                deletedTestimonial: action.payload
            };
        default :
            return state;
    }
}
